// extracted by mini-css-extract-plugin
module.exports = {"quantityChanger":"_8I7ZaUf","minusButton":"fUm4uvF","plusButton":"_1M_KfAz","toBasketButton":"_2G39d6M","invalid":"_3_HKwh8"};